import { Pipe, PipeTransform } from '@angular/core';
import { VehicleSeverityType, RoiService } from '../service/roi.service';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Pipe({
  name: 'vehicleSeverity'
})
export class VehicleSeverityPipe implements PipeTransform {
  severityStrings: VehicleSeverityType;
  defaultSeverity =  this.i18n({ id: 'SEV0',
  value: 'Sévérité inconnue',
  description: 'Sévérité inconnue',
  meaning: 'severity'
});

  constructor(private readonly _roiService: RoiService,
    private readonly i18n: I18n) {
    if (_roiService)
      this.severityStrings = _roiService.vehicleSeverityTypes;
  }

  transform(value: any, args?: any): any {
    return this.severityStrings[value] || this.defaultSeverity;
  }

}


// WEBPACK FOOTER //
// ./src/app/pipes/vehicle-severity.pipe.ts